import { render, staticRenderFns } from "./WeatherExtract.vue?vue&type=template&id=b0b4f20a&scoped=true"
import script from "./WeatherExtract.vue?vue&type=script&lang=ts"
export * from "./WeatherExtract.vue?vue&type=script&lang=ts"
import style0 from "./WeatherExtract.vue?vue&type=style&index=0&id=b0b4f20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b4f20a",
  null
  
)

export default component.exports